/**
 *
 * useSelectMeetingLocationType
 *
 */

import { useApi2call } from 'containers/Api2/index.js';
import useDialog from 'containers/Dialog/useDialog.js';
import messages from '../messages.js';
import { LOCATION_TYPE_PREMISES, LOCATION_TYPE_VIDEO } from '../Planner/SelectLocationType/constants.js';

function useMeetingLocationType() {
  const api2call = useApi2call();
  const { dlgPrompt } = useDialog();

  function saveMeetingLocationType(setId, meetingId, meetingLocationType) {
    return api2call({
      method: 'PUT',
      url: `meetings/sets/${setId}/meetings/${meetingId}/meetingLocationType`,
      selector: `meetings/sets/${setId}/meetings/${meetingId}`,
      body: { meetingLocationType },
      withPromise: true,
    });
  }

  function selectMeetingLocationType(value) {
    const options = [
      { value: LOCATION_TYPE_PREMISES, label: messages.onPremises },
      { value: LOCATION_TYPE_VIDEO, label: messages.videoMeeting },
    ];
    return dlgPrompt({
      title: messages.meetingLocationType,
      message: messages.selectLocationType,
      type: 'radio',
      options,
      value,
      required: true,
      help: messages.videoExplain1,
    }).catch((v) => v);
  }

  return { saveMeetingLocationType, selectMeetingLocationType };
}

export default useMeetingLocationType;
